import { render, staticRenderFns } from "./productGroupsTable.vue?vue&type=template&id=7ad41799&"
import script from "./productGroupsTable.vue?vue&type=script&lang=js&"
export * from "./productGroupsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports